import gql from 'graphql-tag'

export const companyUpdateContactEmails = gql`
  mutation companyUpdateContactEmails($input: CompanyUpdateContactEmailsInput!) {
    companyUpdateContactEmails(input: $input) {
      success
    }
  }
`
